import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(()=>({
        icon: {
            fontSize: '40px',
            width: '100%'
        }
    }));
export { useStyles };
